export const CONTACT_EMAIL = 'minu@my-minu.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;

export const COMPANY_LEGAL_NAME = 'MyMinu UG (haftungsbeschränkt)';
export const COMPANY_SHORT_NAME = 'MyMinu UG';
export const COMPANY_STREET = 'Liztstr. 12';
export const COMPANY_CITY = 'München';
export const COMPANY_COUNTRY = 'Deutschland';
